export default "__VITE_ASSET__DebCuZQZ__"